module.exports = __webpack_public_path__ + "static/media/underarmour.d56d2893.webp";